export default function Schedule() {
  const handleContactClick = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="schedule" className="py-20 bg-gradient-to-b from-[#F5F9F7] to-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-3">Horarios</h2>
          <p className="text-3xl font-semibold text-[#FF7F6E]">
            ¡Nos adaptamos a ti!
          </p>
        </div>

        <div className="bg-white rounded-3xl shadow-lg p-10 mb-8 relative overflow-hidden">
          <div className="absolute top-6 right-6 w-16 h-16 flex items-center justify-center text-[#A8C5B0] opacity-20">
            <i className="ri-time-line text-6xl"></i>
          </div>
          
          <div className="relative z-10">
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              Nuestro horario habitual es de <strong className="text-[#FF7F6E]">9:00 a.m. a 4:00 p.m.</strong>, pero sabemos que cada familia es diferente. Por eso, ofrecemos <strong className="text-[#A8C5B0]">horarios extendidos</strong> tanto en la mañana como en la tarde, pensados para facilitar tu día a día.
            </p>
          </div>
        </div>

        <div className="text-center bg-white rounded-3xl shadow-md p-8">
          <p className="text-lg text-gray-700 mb-5">
            ¿Necesitas algo especial? ¡Encontraremos la mejor opción para ti!
          </p>
          <button
            onClick={handleContactClick}
            className="bg-[#FF7F6E] hover:bg-[#FF6B57] text-white font-semibold px-10 py-4 rounded-full text-lg transition-all duration-300 shadow-md hover:shadow-xl transform hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            ¡Hablemos!
          </button>
        </div>
      </div>
    </section>
  );
}
